import React, { useState, useCallback } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import Form from './form';
import FormModal from '../../../../FormModal';
import useStyles from './styles';

const ModalCheckin = ({
  hasQueueOrder,
  open,
  onClose,
  onConfirm,
}) => {

  const classes = useStyles();

  const [openSnackbarSuccess, setOpenSnackbarSuccess] = useState(false);
  const [openSnackbarError, setOpenSnackbarError] = useState(false);

  const [errorMessage, setErrorMessage] = useState('');

  const handleCloseSnackbarSuccess = (_event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbarSuccess(false);
  };

  const handleCloseSnackbarError = (_event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbarError(false);
  };

  const handleCancel = useCallback(() => {
    onClose();
  }, [onClose]);

  const handleConfirm = useCallback(async (payload) => {
    try {
      const response = await onConfirm(payload);
      if(response?.success === false ){
        setOpenSnackbarError(true);
        setErrorMessage(response.message);
        return response;
      }
      setOpenSnackbarSuccess(true);
      return response;
    } catch (e) {
      setOpenSnackbarError(true);
      setErrorMessage(e?.info?.title);
      throw e;
    }
  }, [onConfirm, setOpenSnackbarSuccess, setOpenSnackbarError, setErrorMessage]);

  return (
    <FormModal
      open={open}
      handleClose={handleCancel}
      showIconClose={true}
      title="Informações para chamado do motorista"
    >
      <Snackbar className={classes.snackbar} open={openSnackbarSuccess} autoHideDuration={6000} onClose={handleCloseSnackbarSuccess}>
        <Alert severity="success">
          Dados salvos com sucesso!
        </Alert>
      </Snackbar>
      <Snackbar className={classes.snackbar} open={openSnackbarError} autoHideDuration={6000} onClose={handleCloseSnackbarError}>
        <Alert severity="error">{errorMessage}</Alert>
      </Snackbar>
      <Form
        hasQueueOrder={hasQueueOrder}
        onSubmit={handleConfirm}
      />
    </FormModal>
  );
};

export default ModalCheckin;
